import { Paper, Typography } from "@mui/material";

type Props = {
  title: string;
  children: React.ReactNode;
  variant?: "card" | "transparent";
};

export function ScreenSectionTitle({ title }: Pick<Props, "title">) {
  return (
    <Typography variant="h2" sx={{ my: 2 }}>
      {title}
    </Typography>
  );
}

/**
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/section
 */
export default function ScreenSection({ title, children, variant }: Props) {
  return (
    <section>
      <ScreenSectionTitle title={title} />
      {!variant || variant === "card" ? (
        <Paper variant="outlined" sx={{ py: 2, px: 3, borderRadius: 4 }}>
          {children}
        </Paper>
      ) : (
        <>{children}</>
      )}
    </section>
  );
}
